import { Component } from '@angular/core';

import { RouterLink } from '@angular/router';
// Relative, not '@cnt-workspace/ui': that barrel exports this very component,
// so importing it here made index.ts depend on itself.
import { CinematicRollDirective } from '../directives/cinematic-roll.directive';

@Component({
  selector: 'cnt-home-locations',
  standalone: true,
  imports: [RouterLink, CinematicRollDirective],
  templateUrl: './home-locations.component.html',
  styleUrl: './home-locations.component.scss'
})
export class HomeLocationsComponent {
  locationsExpanded = true;

  toggleLocations(): void {
    this.locationsExpanded = !this.locationsExpanded;
  }
}
